define('requester/requester',['./json', './jsonp'], function(json, jsonp) {
    'use strict';
    var useJsonp = false;
    var useHttp = false;

    return {
        useJsonp: function(use) {
            useJsonp = use;
        },

        useHttp: function(use) {
            useHttp = use;
        },

        protocol: function() {
            return useHttp ? 'http' : 'https';
        },

        get: function(options) {
            options.protocol = options.protocol || this.protocol();
            return useJsonp ? jsonp.get(options) : json.get(options);
        }
    };
});

